import clsx from "clsx";
import React, { useContext } from "react";
import { twMerge } from "tailwind-merge";

import HPTabs from "../../components/HumanPraticsTabs";
import PrincipalBanner from "../../contents/PrincipalBanner";
import { I18nContext } from "../../i18n/useI18n";

const hpPageContent = "pages.public-engagement.human-practices";

const HumanPractices: React.FC = () => {
  const { t } = useContext(I18nContext);
  return (
    <main className="mx-auto my-0 max-w-7xl">
      <PrincipalBanner>
        classNames={twMerge(clsx("min-h-[200px] md:min-h-[400px]"))}
        <img
          className="absolute w-full min-h-full object-cover"
          src="https://static.igem.wiki/teams/5058/novas-imagens/banner-novo-human.webp"
          alt="bannner education"
        />
        <h1 className="absolute invisible">{t(`${hpPageContent}.title`)}</h1>
      </PrincipalBanner>
      <section>
        <blockquote className="mt-6 mb-4 text-center">
          <p className="font-bold font-manjari text-4xl">
            "{t(`${hpPageContent}.quote.text`)}"
            <br />
            <span className="block text-right m-auto mr-0">
              - {t(`${hpPageContent}.quote.source`)}
            </span>
          </p>
        </blockquote>
        <section className="mt-6 mb-4 text-center">
          <p className="font-manjari text-3xl">
            {t(`${hpPageContent}.introduction.text`)}
          </p>
        </section>
        <section>
          <h2 className="text-center">
            {t(`${hpPageContent}.overview.title`)}
          </h2>
          <article className="bg-gray-highlight py-3">
            <h2 className="font-normal font-nunito text-3xl text-center">
              {t(`${hpPageContent}.overview.categories.importance.title`)}
            </h2>
            <p>
              {t(`${hpPageContent}.overview.categories.importance.description`)}
            </p>
            <p>
              {t(
                `${hpPageContent}.overview.categories.importance.description2`
              )}
            </p>
            <p>
              {t(
                `${hpPageContent}.overview.categories.importance.description3`
              )}
            </p>
            <ul className="mb-4 p-3 font-semibold text-lg indent-3">
              <li>
                {t(
                  `${hpPageContent}.overview.categories.importance.description4`
                )}
              </li>
              <li>
                {t(
                  `${hpPageContent}.overview.categories.importance.description5`
                )}
              </li>
              <li>
                {t(
                  `${hpPageContent}.overview.categories.importance.description6`
                )}
              </li>
              <li>
                {t(
                  `${hpPageContent}.overview.categories.importance.description7`
                )}
              </li>
              <li>
                {t(
                  `${hpPageContent}.overview.categories.importance.description8`
                )}
              </li>
              <li>
                {t(
                  `${hpPageContent}.overview.categories.importance.description9`
                )}
              </li>
              <li>
                {t(
                  `${hpPageContent}.overview.categories.importance.description10`
                )}
              </li>
              <li>
                {t(
                  `${hpPageContent}.overview.categories.importance.description11`
                )}
              </li>
            </ul>

            <h2 className="font-normal font-nunito text-3xl text-center">
              {t(`${hpPageContent}.overview.categories.purpose.title`)}
            </h2>
            <p>
              {t(`${hpPageContent}.overview.categories.purpose.description`)}
            </p>
          </article>
        </section>

        <HPTabs
          tabs={[
            t(`${hpPageContent}.overview.idea.title`),
            t(`${hpPageContent}.overview.ethics.title`),
            t(`${hpPageContent}.overview.application.title`),
            t(`${hpPageContent}.overview.sustainability.title`),
            t(`${hpPageContent}.overview.opportunities.title`),
            t(`${hpPageContent}.overview.viability.title`),
            t(`${hpPageContent}.overview.entry.title`),
            t(`${hpPageContent}.overview.innovation.title`),
          ]}
          className="relative flex flex-col justify-center w-full sidebar"
        >
          <section data-name={t(`${hpPageContent}.overview.idea.title`)}>
            <article
              data-highlight={true}
              className="flex justify-center align-items-center"
            >
              <img
                className="w-full h-full"
                src="https://static.igem.wiki/teams/5058/imgs/entrevistado-idea-human-practice.webp"
                alt=""
              />
            </article>
            <article
              data-info={true}
              data-title={t(`${hpPageContent}.overview.idea.title`)}
              data-image={
                "https://static.igem.wiki/teams/5058/gabriel-soares.svg"
              }
              data-name="profile gabriel soares"
            >
              <div
                data-content="profile"
                data-title={t(
                  `${hpPageContent}.overview.idea.categories.gabriel.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.idea.categories.gabriel.description`
                  )}
                </p>
                <p>
                  {t(
                    `${hpPageContent}.overview.idea.categories.gabriel.description2`
                  )}
                </p>
              </div>
              <div
                data-content="purpose"
                data-title={t(
                  `${hpPageContent}.overview.idea.categories.purpose.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.idea.categories.purpose.description`
                  )}
                </p>
              </div>
              <div
                data-content="key"
                data-title={t(
                  `${hpPageContent}.overview.idea.categories.key.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.idea.categories.key.description`
                  )}
                </p>
                <p>
                  {t(
                    `${hpPageContent}.overview.idea.categories.key.description2`
                  )}
                </p>
                <p>
                  {t(
                    `${hpPageContent}.overview.idea.categories.key.description3`
                  )}
                </p>
              </div>
            </article>

            <article>
              <h2 className="text-4xl text-center">
                {t(`${hpPageContent}.overview.idea.categories.resume.title`)}
              </h2>
              <p>
                {t(
                  `${hpPageContent}.overview.idea.categories.resume.description`
                )}
              </p>
              <p>
                {t(
                  `${hpPageContent}.overview.idea.categories.resume.description2`
                )}
              </p>
              <p>
                {t(
                  `${hpPageContent}.overview.idea.categories.resume.description3`
                )}
              </p>
            </article>
            <article>
              <h2 className="text-4xl text-center">
                {t(`${hpPageContent}.overview.idea.categories.learned.title`)}
              </h2>
              <p>
                {t(
                  `${hpPageContent}.overview.idea.categories.learned.description`
                )}
              </p>
            </article>
          </section>
          <section data-name={t(`${hpPageContent}.overview.ethics.title`)}>
            <article
              data-highlight={true}
              className="flex justify-center align-items-center"
            >
              <img
                className="w-full max-w-max h-full"
                src="https://static.igem.wiki/teams/5058/imgs/entrevistado-2-ethics-human-practice.webp"
                alt=""
              />
            </article>
            <article
              data-info={true}
              data-title={t(`${hpPageContent}.overview.ethics.title`)}
              data-image={
                "https://static.igem.wiki/teams/5058/jasmin-g-t-souza.svg"
              }
            >
              <div
                data-content="profile"
                data-title={t(
                  `${hpPageContent}.overview.ethics.categories.jasmin.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.ethics.categories.jasmin.description`
                  )}
                </p>
              </div>

              <div
                data-content="purpose"
                data-title={t(
                  `${hpPageContent}.overview.ethics.categories.purpose.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.ethics.categories.purpose.description`
                  )}
                </p>
              </div>

              <div
                data-content="key"
                data-title={t(
                  `${hpPageContent}.overview.ethics.categories.key.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.ethics.categories.key.description`
                  )}
                </p>
                <p>
                  {t(
                    `${hpPageContent}.overview.ethics.categories.key.description2`
                  )}
                </p>
                <p>
                  {t(
                    `${hpPageContent}.overview.ethics.categories.key.description3`
                  )}
                </p>
              </div>
            </article>
            <article>
              <h2 className="text-4xl text-center">
                {t(`${hpPageContent}.overview.ethics.categories.resume.title`)}
              </h2>
              <p>
                {t(
                  `${hpPageContent}.overview.ethics.categories.resume.description`
                )}
              </p>
              <p>
                {t(
                  `${hpPageContent}.overview.ethics.categories.resume.description2`
                )}
              </p>
              <p>
                {t(
                  `${hpPageContent}.overview.ethics.categories.resume.description3`
                )}
              </p>
            </article>
            <article>
              <h2 className="text-4xl text-center">
                {t(`${hpPageContent}.overview.ethics.categories.learned.title`)}
              </h2>
              <p>
                {t(
                  `${hpPageContent}.overview.ethics.categories.learned.description`
                )}
              </p>
            </article>
          </section>
          <section data-name={t(`${hpPageContent}.overview.application.title`)}>
            <article
              data-highlight={true}
              className="flex justify-center align-items-center"
            >
              <img
                className="w-full max-w-max h-full"
                src="https://static.igem.wiki/teams/5058/entrevistado-3-aplication-human-practice.png"
                alt=""
              />
            </article>
            <article
              data-info={true}
              data-title={t(`${hpPageContent}.overview.application.title`)}
              data-image={
                "https://static.igem.wiki/teams/5058/kassia-lopes-2.svg"
              }
            >
              <div
                data-content="profile"
                data-title={t(
                  `${hpPageContent}.overview.application.categories.kassia.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.application.categories.kassia.description`
                  )}
                </p>
              </div>
              <div
                data-content="purpose"
                data-title={t(
                  `${hpPageContent}.overview.application.categories.purpose.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.application.categories.purpose.description`
                  )}
                </p>
              </div>
              <div
                data-content="key"
                data-title={t(
                  `${hpPageContent}.overview.application.categories.key.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.application.categories.key.description`
                  )}
                </p>
                <p>
                  {t(
                    `${hpPageContent}.overview.application.categories.key.description2`
                  )}
                </p>
                <p>
                  {t(
                    `${hpPageContent}.overview.application.categories.key.description3`
                  )}
                </p>
              </div>
            </article>
            <article>
              <h2 className="text-4xl text-center">
                {t(
                  `${hpPageContent}.overview.application.categories.resume.title`
                )}
              </h2>
              <p>
                {t(
                  `${hpPageContent}.overview.application.categories.resume.description`
                )}
              </p>
              <p>
                {t(
                  `${hpPageContent}.overview.application.categories.resume.description2`
                )}
              </p>
              <p>
                {t(
                  `${hpPageContent}.overview.application.categories.resume.description3`
                )}
              </p>
            </article>
            <article>
              <h2 className="text-4xl text-center">
                {t(
                  `${hpPageContent}.overview.application.categories.learned.title`
                )}
              </h2>
              <p>
                {t(
                  `${hpPageContent}.overview.application.categories.learned.description`
                )}
              </p>
            </article>
          </section>
          <section
            data-name={t(`${hpPageContent}.overview.sustainability.title`)}
          >
            <article
              data-highlight={true}
              className="flex justify-center align-items-center"
            >
              <img
                className="w-full max-w-max h-full"
                src="https://static.igem.wiki/teams/5058/entrevistado-4-sustainability-human-practice.png"
                alt=""
              />
            </article>
            <article
              data-info={true}
              data-title={t(`${hpPageContent}.overview.sustainability.title`)}
              data-image={
                "https://static.igem.wiki/teams/5058/leandro-dos-santos.svg"
              }
            >
              <div
                data-content="profile"
                data-title={t(
                  `${hpPageContent}.overview.sustainability.categories.leandro.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.sustainability.categories.leandro.description`
                  )}
                </p>
              </div>
              <div
                data-content="purpose"
                data-title={t(
                  `${hpPageContent}.overview.sustainability.categories.purpose.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.sustainability.categories.purpose.description`
                  )}
                </p>
              </div>

              <div
                data-content="key"
                data-title={t(
                  `${hpPageContent}.overview.sustainability.categories.key.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.sustainability.categories.key.description`
                  )}
                </p>
                <p>
                  {t(
                    `${hpPageContent}.overview.sustainability.categories.key.description2`
                  )}
                </p>
                <p>
                  {t(
                    `${hpPageContent}.overview.sustainability.categories.key.description3`
                  )}
                </p>
              </div>
            </article>
            <article>
              <h2 className="text-4xl text-center">
                {t(
                  `${hpPageContent}.overview.sustainability.categories.resume.title`
                )}
              </h2>
              <p>
                {t(
                  `${hpPageContent}.overview.sustainability.categories.resume.description`
                )}
              </p>
              <p>
                {t(
                  `${hpPageContent}.overview.sustainability.categories.resume.description2`
                )}
              </p>
            </article>
            <article>
              <h2 className="text-4xl text-center">
                {t(
                  `${hpPageContent}.overview.sustainability.categories.learned.title`
                )}
              </h2>
              <p>
                {t(
                  `${hpPageContent}.overview.sustainability.categories.learned.description`
                )}
              </p>
            </article>
          </section>
          <section
            data-name={t(`${hpPageContent}.overview.opportunities.title`)}
          >
            <article
              data-highlight={true}
              className="flex justify-center align-items-center"
            >
              <img
                className="w-full max-w-max h-full"
                src="https://static.igem.wiki/teams/5058/entrevistado-5-market-opportunities-human-practice.png"
                alt=""
              />
            </article>
            <article
              data-info={true}
              data-title={t(`${hpPageContent}.overview.opportunities.title`)}
              data-image={"https://static.igem.wiki/teams/5058/cezar-halim.svg"}
            >
              <div
                data-content="profile"
                data-title={t(
                  `${hpPageContent}.overview.opportunities.categories.cezar.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.opportunities.categories.cezar.description`
                  )}
                </p>
              </div>
              <div
                data-content="purpose"
                data-title={t(
                  `${hpPageContent}.overview.opportunities.categories.purpose.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.opportunities.categories.purpose.description`
                  )}
                </p>
              </div>
              <div
                data-content="key"
                data-title={t(
                  `${hpPageContent}.overview.opportunities.categories.key.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.opportunities.categories.key.description`
                  )}
                </p>
                <p>
                  {t(
                    `${hpPageContent}.overview.opportunities.categories.key.description2`
                  )}
                </p>
                <p>
                  {t(
                    `${hpPageContent}.overview.opportunities.categories.key.description3`
                  )}
                </p>
              </div>
            </article>

            <article>
              <h2 className="text-4xl text-center">
                {t(
                  `${hpPageContent}.overview.opportunities.categories.resume.title`
                )}
              </h2>
              <p>
                {t(
                  `${hpPageContent}.overview.opportunities.categories.resume.description`
                )}
              </p>
              <p>
                {t(
                  `${hpPageContent}.overview.opportunities.categories.resume.description2`
                )}
              </p>
            </article>
            <article>
              <h2 className="text-4xl text-center">
                {t(
                  `${hpPageContent}.overview.opportunities.categories.learned.title`
                )}
              </h2>
              <p>
                {t(
                  `${hpPageContent}.overview.opportunities.categories.learned.description`
                )}
              </p>
            </article>
          </section>
          <section data-name={t(`${hpPageContent}.overview.viability.title`)}>
            <article
              data-highlight={true}
              className="flex justify-center align-items-center"
            >
              <img
                className="w-full max-w-max h-full"
                src="https://static.igem.wiki/teams/5058/entrevistado-6-economic-viability-human-practice.png"
                alt=""
              />
            </article>
            <article
              data-info={true}
              data-title={t(`${hpPageContent}.overview.viability.title`)}
              data-image={
                "https://static.igem.wiki/teams/5058/carlos-breyer.svg"
              }
            >
              <div
                data-content="profile"
                data-title={t(
                  `${hpPageContent}.overview.viability.categories.carlos.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.viability.categories.carlos.description`
                  )}
                </p>
              </div>
              <div
                data-content="purpose"
                data-title={t(
                  `${hpPageContent}.overview.viability.categories.purpose.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.viability.categories.purpose.description`
                  )}
                </p>
              </div>
              <div
                data-content="key"
                data-title={t(
                  `${hpPageContent}.overview.viability.categories.key.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.viability.categories.key.description`
                  )}
                </p>
                <p>
                  {t(
                    `${hpPageContent}.overview.viability.categories.key.description2`
                  )}
                </p>
                <p>
                  {t(
                    `${hpPageContent}.overview.viability.categories.key.description3`
                  )}
                </p>
              </div>
            </article>
            <article>
              <h2 className="text-4xl text-center">
                {t(
                  `${hpPageContent}.overview.viability.categories.resume.title`
                )}
              </h2>
              <p>
                {t(
                  `${hpPageContent}.overview.viability.categories.resume.description`
                )}
              </p>
              <p>
                {t(
                  `${hpPageContent}.overview.viability.categories.resume.description2`
                )}
              </p>
              <p>
                {t(
                  `${hpPageContent}.overview.viability.categories.resume.description3`
                )}
              </p>
            </article>
            <article>
              <h2 className="text-4xl text-center">
                {t(
                  `${hpPageContent}.overview.viability.categories.learned.title`
                )}
              </h2>
              <p>
                {t(
                  `${hpPageContent}.overview.viability.categories.learned.description`
                )}
              </p>
            </article>
          </section>
          <section data-name={t(`${hpPageContent}.overview.entry.title`)}>
            <article
              data-highlight={true}
              className="flex justify-center align-items-center"
            >
              <img
                className="w-full max-w-max h-full"
                src="https://static.igem.wiki/teams/5058/entrevistado-7-market-entry-strategies-human-practice.png"
                alt=""
              />
            </article>
            <article
              data-info={true}
              data-title={t(`${hpPageContent}.overview.entry.title`)}
              data-image={
                "https://static.igem.wiki/teams/5058/victor-de-lucca.svg"
              }
            >
              <div
                data-content="profile"
                data-title={t(
                  `${hpPageContent}.overview.entry.categories.victor.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.entry.categories.victor.description`
                  )}
                </p>
                <p>
                  {t(
                    `${hpPageContent}.overview.entry.categories.victor.description2`
                  )}
                </p>
              </div>
              <div
                data-content="purpose"
                data-title={t(
                  `${hpPageContent}.overview.entry.categories.purpose.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.entry.categories.purpose.description`
                  )}
                </p>
              </div>
              <div
                data-content="key"
                data-title={t(
                  `${hpPageContent}.overview.entry.categories.key.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.entry.categories.key.description`
                  )}
                </p>
                <p>
                  {t(
                    `${hpPageContent}.overview.entry.categories.key.description2`
                  )}
                </p>
                <p>
                  {t(
                    `${hpPageContent}.overview.entry.categories.key.description3`
                  )}
                </p>
              </div>
            </article>
            <article>
              <h2 className="text-4xl text-center">
                {t(`${hpPageContent}.overview.entry.categories.resume.title`)}
              </h2>
              <p>
                {t(
                  `${hpPageContent}.overview.entry.categories.resume.description`
                )}
              </p>
              <p>
                {t(
                  `${hpPageContent}.overview.entry.categories.resume.description2`
                )}
              </p>
            </article>
            <article>
              <h2 className="text-4xl text-center">
                {t(`${hpPageContent}.overview.entry.categories.learned.title`)}
              </h2>
              <p>
                {t(
                  `${hpPageContent}.overview.entry.categories.learned.description`
                )}
              </p>
            </article>
          </section>
          <section data-name={t(`${hpPageContent}.overview.innovation.title`)}>
            <article
              data-highlight={true}
              className="flex justify-center align-items-center"
            >
              <img
                className="w-full max-w-max h-full"
                src="https://static.igem.wiki/teams/5058/entrevistado-8-innovation-and-intellectual-property-human-practice.png"
                alt=""
              />
            </article>
            <article
              data-info={true}
              data-title={t(`${hpPageContent}.overview.innovation.title`)}
              data-image={""}
            >
              <div
                data-content="profile"
                data-title={t(
                  `${hpPageContent}.overview.innovation.categories.inova.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.innovation.categories.inova.description`
                  )}
                </p>
              </div>
              <div
                data-content="purpose"
                data-title={t(
                  `${hpPageContent}.overview.innovation.categories.purpose.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.innovation.categories.purpose.description`
                  )}
                </p>
              </div>
              <div
                data-content="key"
                data-title={t(
                  `${hpPageContent}.overview.innovation.categories.key.title`
                )}
              >
                <p>
                  {t(
                    `${hpPageContent}.overview.innovation.categories.key.description`
                  )}
                </p>
                <p>
                  {t(
                    `${hpPageContent}.overview.innovation.categories.key.description2`
                  )}
                </p>
                <p>
                  {t(
                    `${hpPageContent}.overview.innovation.categories.key.description3`
                  )}
                </p>
              </div>
            </article>
            <article>
              <h2 className="text-4xl text-center">
                {t(
                  `${hpPageContent}.overview.innovation.categories.resume.title`
                )}
              </h2>
              <p>
                {t(
                  `${hpPageContent}.overview.innovation.categories.resume.description`
                )}
              </p>
              <p>
                {t(
                  `${hpPageContent}.overview.innovation.categories.resume.description2`
                )}
              </p>
              <p>
                {t(
                  `${hpPageContent}.overview.innovation.categories.resume.description3`
                )}
              </p>
            </article>
            <article>
              <h2 className="text-4xl text-center">
                {t(
                  `${hpPageContent}.overview.innovation.categories.learned.title`
                )}
              </h2>
              <p>
                {t(
                  `${hpPageContent}.overview.innovation.categories.learned.description`
                )}
              </p>
            </article>
          </section>
        </HPTabs>

        <section>
          <h2>{t(`${hpPageContent}.overview.conclusion.title`)}</h2>
          <p>{t(`${hpPageContent}.overview.conclusion.text`)}</p>
        </section>
      </section>
    </main>
  );
};

export default HumanPractices;
